// extracted by mini-css-extract-plugin
export default {"howToParticipateCard":"HelpVIdeoCard_howToParticipateCard__p3bIp"};